import { CountryCodes } from "../types/amazonAds"
import { LocalStorageKeys } from "../types/localStorage"

export const COUNTRY_CODES_ENUM = [CountryCodes.US, CountryCodes.CA, CountryCodes.MX]

const readStoredCountryCodes = (): string[] => {
  try {
    const parsed = JSON.parse(
      localStorage.getItem(LocalStorageKeys.AVAILABLE_COUNTRY_CODES) || "[]"
    )
    if (!Array.isArray(parsed)) return []
    return parsed.filter((code): code is string => typeof code === "string" && code.length > 0)
  } catch {
    return []
  }
}

export const getAvailableCountryCodes = (): string[] => {
  const stored = readStoredCountryCodes()
  return stored.length > 0 ? stored : COUNTRY_CODES_ENUM
}
